/** True when the workspace has no UI-count cap (missing, zero, or negative). */
export const hasUnlimitedUICount = (uiCountMax: number) => !uiCountMax || uiCountMax <= 0;

export const isAuthCheckUnauthorized = (status?: number) => status === 401;

/** Network failures and 5xx responses during /auth/check should not sign the user out. */
export const isAuthCheckTransientError = (status?: number) =>
    status == null || status >= 500;

const UICountThreshold = {
    blocking: 1.0,
};

export const isUICountWithinLimit = (uiCount: number, uiCountMax: number) =>
    hasUnlimitedUICount(uiCountMax) ||
    uiCount / uiCountMax < UICountThreshold.blocking;
